import { dialogAnatomy } from "@ark-ui/react/dialog";
import { defineSlotRecipe } from "@chakra-ui/react";

export default defineSlotRecipe({
  className: "chakra-dialog",
  slots: dialogAnatomy.extendWith("header", "body", "footer").keys(),
  base: {
    backdrop: {
      background: "overlay",
    },
    content: {
      borderRadius: "l2",
      boxShadow: "dialog",
      gap: "4",
      padding: "6",
    },
    header: {
      padding: "0",
    },
    body: {
      padding: "0",
    },
    footer: {
      padding: "0",
    },
    title: {
      fontFamily: "inter",
      fontSize: "lg",
      fontWeight: "semibold",
      lineHeight: "28px" as any,
    },
  },
});
